import * as React from 'react'
import { TRIPS_HISTORY_COLUMNS } from '../../state/constants/index'
import { ITripHistoryObject } from '../../types/index'
import TripsHistoryListItem from './TripsHistoryListItem'

interface ITripsHistoryListProps {
  items: ITripHistoryObject[]
  columns: TRIPS_HISTORY_COLUMNS[]
  getTripsHistory: (orgId: string) => void
  orgId: string
}

class TripsHistoryList extends React.Component<ITripsHistoryListProps> {
  public componentWillMount() {
    this.props.getTripsHistory(this.props.orgId)
  }

  public render() {
    return (
      <div>
        {Object.values(this.props.items).map((it: any) => (
          <TripsHistoryListItem trip={it} columns={this.props.columns} key={`trips-history-item-${it.id}`} />
        ))}
      </div>
    )
  }
}

export default TripsHistoryList



// WEBPACK FOOTER //
// ./src/components/trips/TripsHistoryList.tsx